import { QueryResult, useQuery, QueryOptions } from '@eika-infrastruktur/react-query';
import { RequestExceptionWithResponse } from '@eika-infrastruktur/request';

import { CustomerTask } from '../generated-types';
import { getCustomerTasks } from '../services/kredittbankenTasksService';

const KREDITTBANKEN_CUSTOMER_TASK_QUERY_KEY = 'kredittbanken-customer-tasks';

export const useKredittbankenTasks = (
    options: Partial<QueryOptions<CustomerTask[], RequestExceptionWithResponse>> = { enabled: false },
): QueryResult<CustomerTask[]> =>
    useQuery({
        ...options,
        queryKey: [KREDITTBANKEN_CUSTOMER_TASK_QUERY_KEY],
        queryFn: getCustomerTasks,
    });
